export default __webpack_public_path__ + "f053ff1a6bb54bc4f4b7c9622cc189bf.jpg";